import React, { useRef, useState } from 'react';
import Draggable from 'react-draggable';
import { Modal, Typography } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';

import './traceableCommentModal.less';

const { Text } = Typography;

function StyledModal(props) {
  const { wrapClassName, isLoading, loadingContent, title, ...rest } = props;
  const dragRef = useRef(null);
  const [disabled, setDisabled] = useState(false);

  const mapToLoadingContent = () => {
    if (!loadingContent) return {};

    const RenderLoading = (
      <>
        <LoadingOutlined />
        <Text style={{ color: 'white' }}>{loadingContent?.loadingText}</Text>
      </>
    );

    return isLoading
      ? { okText: RenderLoading }
      : { okText: loadingContent?.originalText };
  };

  return (
    <Modal
      wrapClassName={`styled-modal ${wrapClassName || ''}`}
      maskClosable={false}
      modalRender={(modal) => (
        <Draggable
          nodeRef={dragRef}
          handle='.ant-modal-header' // Makes the full header draggable
          bounds='body' // Prevents dragging out of screen
          disabled={disabled}
          onStart={() => {
            document.body.style.cursor = 'grabbing'; // Change cursor when dragging starts
          }}
          onStop={() => {
            document.body.style.cursor = 'auto'; // Reset cursor after dragging stops
          }}
        >
          <div ref={dragRef}>{modal}</div>
        </Draggable>
      )}
      title={
        <div
          className='styled-modal-title-container' // ✅ Changed class name to avoid extra line issue
          onMouseEnter={() => setDisabled(false)}
          onMouseLeave={() => setDisabled(true)}
        >
          <div className='ant-modal-title'>{title}</div>
        </div>
      }
      {...rest}
      {...mapToLoadingContent()}
    >
      {props.children}
    </Modal>
  );
}

export default StyledModal;
